<template>
  <v-card
    outlined
    class="px-6 mt-6"
  >
    <div class="d-flex flex-row justify-space-between">
      <label class="subtitle-1 grey--text pb-3 pt-1 mt-4">Bookmaker Code</label>
    </div>
    <v-text-field
      outlined
      flat
      label="Bookmaker Code"
      v-model="bookmakerCodeListener"
      :error-messages="errorMessages"
    />
  </v-card>
</template>

<script>
export default {
  props: {
    bookmakerCode: {
      type: String,
      default: null
    },
    errorMessages: {
      type: [String, Array, Object],
      default () {
        return null
      }
    },
  },

  computed: {
    bookmakerCodeListener: {
      get () {
        return this.bookmakerCode
      },
      set (val) {
        this.$emit('update:bookmakerCode', val)
      }
    }

  }
}
</script>
